import * as React from 'react';
import { FC } from 'react';

import Picture from 'components/picture';
import { IImageFragment } from 'generated/sanity-graphql';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useLoyaltyUser } from 'state/loyalty/hooks/use-loyalty-user';
import { isActiveWalmartUser } from 'state/loyalty/hooks/utils/walmart';

import { OfferGroupItem } from './offer-group-item';

export interface ILoyaltyOfferGroupItem {
  handlePress: () => void;
  groupId: string;
  name: string;
  description: string;
  image: IImageFragment | null;
  imageDescription: string;
  endDate?: string;
  unavailable?: boolean;
  unavailableMessage?: string;
  isWalmartOffer?: boolean;
}

export const LoyaltyOfferGroupItem: FC<ILoyaltyOfferGroupItem> = ({
  handlePress,
  name,
  description,
  groupId,
  image,
  imageDescription,
  endDate,
  unavailable,
  unavailableMessage,
  isWalmartOffer,
}) => {
  const { loyaltyUser } = useLoyaltyUser();
  const enableWalmartPlusIntegration = useFlag(LaunchDarklyFlag.ENABLE_WALMART_PLUS_INTEGRATION);
  const isWalmartUser = enableWalmartPlusIntegration && isActiveWalmartUser(loyaltyUser);

  return (
    <OfferGroupItem
      name={name}
      description={description}
      groupId={groupId}
      image={
        <Picture image={image} alt={imageDescription} height="97px" width="97px" objectFitContain />
      }
      onPress={handlePress}
      endDate={endDate}
      unavailable={unavailable}
      unavailableMessage={unavailableMessage}
      isWalmartOffer={isWalmartOffer}
      isWalmartUser={isWalmartUser}
    />
  );
};
